module.exports = __webpack_public_path__ + "static/img/icon11.859eb265.png";